import React, { useState } from 'react';
import moment from 'moment';
import {
  Box,
  Typography
} from '@material-ui/core';

import 'react-dates/initialize';
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

const SalesRangePicker = (props) => {

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [focusedInput, setFocusedInput] = useState();
  
  const onDatesChange = ({startDate, endDate}) => {
    setStartDate(startDate);
    setEndDate(endDate);
    if(startDate && endDate) {
      props.showSalesTable(
        {
          startDate: new Date(startDate._d.setHours(0,0,0,0)),
          endDate: new Date(endDate._d.setHours(0,0,0,0))
        },
        props.showBookings
      );
    }
  };

  return (
    <Box>
      <Typography
        style={{ marginTop: 16, marginBottom: 8 }}
        color="textPrimary"
        variant="body1"
      >
        {`Select the Range of Dates to Display ${props.showBookings ? "Bookings" : "Sales"}`}
      </Typography>
      <DateRangePicker
        block
        appendToBody
        startDateId="123456" // PropTypes.string.isRequired,
        endDateId="567890" // PropTypes.string.isRequired,
        startDate={startDate} // momentPropTypes.momentObj or null,
        endDate={endDate} // momentPropTypes.momentObj or null,
        isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
        displayFormat="DD/MM/YYYY"
        onDatesChange={onDatesChange} // PropTypes.func.isRequired,
        focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
        onFocusChange={focusedInput => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
      />
    </Box>
  )
};

export default SalesRangePicker;